var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSulfurCokeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "#29ABE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 56.5398V100.04H100C100 100.04 101 26.0398 100 28.0398C99 30.0398 73 53.5398 70.5 53.0398C68 52.5398 60.5 37.5398 49.5 37.0398C38.5 36.5398 26.5 55.5398 24 55.5398C21.5 55.5398 17.9769 45.9947 12 46.0398C5.77318 46.0868 0 56.5398 0 56.5398Z",
    fill: "#0D0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 56.5398V100.04H100C100 100.04 101 26.0398 100 28.0398C99 30.0398 73 53.5398 70.5 53.0398C68 52.5398 60.5 37.5398 49.5 37.0398C38.5 36.5398 26.5 55.5398 24 55.5398C21.5 55.5398 17.9769 45.9947 12 46.0398C5.77318 46.0868 0 56.5398 0 56.5398Z",
    stroke: "#110F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 56.5398V100.04H100C100 100.04 101 26.0398 100 28.0398C99 30.0398 73 53.5398 70.5 53.0398C68 52.5398 60.5 37.5398 49.5 37.0398C38.5 36.5398 26.5 55.5398 24 55.5398C21.5 55.5398 17.9769 45.9947 12 46.0398C5.77318 46.0868 0 56.5398 0 56.5398Z",
    stroke: "#110F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 100L49.5 36.5C49.5 36.5 50.5 36 52.5 36.5C54.5 37 56 38 56 38L58 39.5L60.5 41.5L71 52.5L85.5 40.5L100 27V63.5V100H50Z",
    fill: "#FCD162"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSulfurCokeIcon);
export default __webpack_public_path__ + "static/media/Sulfur&CokeIcon.f3410b172a3d88aa672479858b7f5b77.svg";
export { ForwardRef as ReactComponent };